import * as Sentry from '@sentry/react';
import axios from 'axios';

export const captureNonApiError = (error: unknown) => {
  if (!axios.isAxiosError(error)) Sentry.captureException(error);
};
